export default (mailAdress) => {
  let isMail = true

  if (typeof mailAdress !== 'string' ||
    mailAdress.indexOf('@') === -1 ||
    mailAdress.indexOf('.') === -1 ||
    mailAdress.indexOf(' ') !== -1) {
    isMail = false
  }

  return isMail
}
